import { FormControl, FormErrorMessage, FormLabel, Textarea } from '@chakra-ui/react';
import { Field } from 'formik';
import { InputFormField } from 'models';
import React, { FunctionComponent } from 'react';

import { getLabelName, validateInputField } from '../../utils/form/validation';

interface TextareaFieldProps {
  model: InputFormField;
}

export const TextareaField: FunctionComponent<TextareaFieldProps> = ({ model }) => {
  return (
    <Field name={model.elements.name.value} validate={validateInputField(model)}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[model.elements.name.value] && form.touched[model.elements.name.value]}>
          {model.elements.label.value !== '' && <FormLabel>{getLabelName(model)}</FormLabel>}
          <Textarea
            {...field}
            placeholder={model.elements.placeholder.value}
            textStyle='mobile.body.s'
            bg={'white'}
            color={'mountain.60'}
          />
          <FormErrorMessage>{form.errors[model.elements.name.value]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
